import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from 'generated/graphql';
import { PageTitleSub } from 'packages/kakapo-ui-kit/components/common/Headings';
import { toRgbString } from 'packages/kakapo-ui-kit/helpers/HexColor';
import usePreferredTranslation from 'packages/kakapo-ui-application/hooks/usePreferredTranslation';
import { useField } from 'formik';

const Title = styled(PageTitleSub)`
	color: ${(props) => props.theme.colors.slateBlue};
`;

const Emoji = styled.div<{ selected: boolean }>`
	width: 48px;
	height: 48px;
	border-radius: 24px;
	font-size: 24px;
	line-height: 50px;
	display: flex;
	justify-content: center;
	cursor: pointer;
	transition: 0.3s ease-in-out all;

	background-color: ${(props) => (props.selected ? props.theme.colors.primary : 'white')};

	&:hover {
		box-shadow: 0px 4px 8px rgba(${(props) => toRgbString(props.theme.colors.primary)}, 0.25);
		transform: scale(1.2, 1.2);

		&:active {
			transform: scale(0.9, 0.9);
		}
	}
`;

export default function Stars(props: {
	name: string;
	item: graphql.EvaluationStarsItem;
	readonly?: boolean;
}) {
	const { translate } = usePreferredTranslation();

	const [field, , { setValue }] = useField<number>(props.name + '.stars');
	const value = field.value ?? -1;

	return (
		<>
			<Title style={{ maxWidth: 600 }}>{translate(props.item.title)}</Title>
			<Flex alignItems="center" mt={2}>
				<Box mr={2}>
					<Emoji selected={value >= 0} onClick={() => props.readonly || setValue(0)}>
						⭐️
					</Emoji>
				</Box>
				<Box mr={2}>
					<Emoji selected={value >= 1} onClick={() => props.readonly || setValue(1)}>
						⭐️
					</Emoji>
				</Box>
				<Box mr={2}>
					<Emoji selected={value >= 2} onClick={() => props.readonly || setValue(2)}>
						⭐️
					</Emoji>
				</Box>
				<Box mr={2}>
					<Emoji selected={value >= 3} onClick={() => props.readonly || setValue(3)}>
						⭐️
					</Emoji>
				</Box>
				<Box mr={2}>
					<Emoji selected={value >= 4} onClick={() => props.readonly || setValue(4)}>
						⭐️
					</Emoji>
				</Box>
			</Flex>
		</>
	);
}
